import { useState, useEffect } from 'react';

type BtnProps = {
  onClick?: () => void;
};

export default function Btn({ onClick }: BtnProps) {
  const defaultUTM =
  "?utm_source=online&utm_medium=website&utm_campaign=website_lead&utm_term=landing_page";

const [utmParams, setUtmParams] = useState<string>(() => {
  // Try to get from localStorage on initial load (e.g. second visit)
  return localStorage.getItem('utm_params') || defaultUTM;
});

useEffect(() => {
  const queryString = window.location.search;
  if (queryString && queryString.includes('utm_')) {
    localStorage.setItem('utm_params', queryString);
    setUtmParams(queryString); // Triggers rerender
  }
}, []);

const signupLink = `https://app.eximpe.com/auth/sign-up${utmParams}`;

  return (
    <a href={signupLink}>
      <button
        onClick={onClick}
        className="hover:scale-[120%] hover:cursor-pointer transition-transform duration-500 bg-[#26a887] text-white rounded-lg px-6 py-2 md:px-8 md:py-3 mt-6 md:mt-5 font-inter"
      >
        Sign Up
      </button>
    </a>
  );
}
